<template>
  <router-link :to="url" class="nav-link" v-bind="$attrs" v-if="!isExternal">
    <div
      class="icon icon-shape icon-md text-center d-flex align-items-center justify-content-center"
    >
      <slot name="icon"></slot>
    </div>
    <span class="nav-link-text ms-1'">{{ navText }}</span>
  </router-link>
  <a :href="url" class="nav-link" v-bind="$attrs" target="_blank" v-else>
    <div
      class="icon icon-shape icon-md text-center d-flex align-items-center justify-content-center"
    >
      <slot name="icon"></slot>
    </div>
    <span class="nav-link-text ms-1'">{{ navText }}</span>
  </a>
</template>
<script>
export default {
  name: "sidenav-item",
  props: {
    url: {
      type: String,
      required: true
    },
    navText: {
      type: String,
      required: true
    },
    isExternal: {
      type: Boolean,
      required: false
    }
  }
};
</script>
